// Returns a Set of entry keys that are new or changed between two Mythodex snapshots.
export function diffMythodex(prev, next) {
  const fresh = new Set();
  if (!next) return fresh;
  const p = prev || {};
  const same = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

  if (next.character && !same(p.character, next.character)) fresh.add("character");

  const byKey = (list, keyFn) => Object.fromEntries((list || []).map((x) => [keyFn(x), x]));
  const groups = [
    ["obj", "objectives", (o) => o.id],
    ["thr", "threads", (t) => t.id],
    ["char", "characters", (c) => c.name],
  ];
  for (const [prefix, field, keyFn] of groups) {
    const old = byKey(p[field], keyFn);
    for (const item of next[field] || []) {
      const k = keyFn(item);
      if (!same(old[k], item)) fresh.add(`${prefix}:${k}`);
    }
  }

  const prevEvents = (p.events || []).length;
  (next.events || []).forEach((_, i) => {
    if (i >= prevEvents) fresh.add(`evt:${i}`);
  });
  return fresh;
}
